/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — multi-step generic form route (dati/modulo/project)
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     none (returns undefined)
 *   key:       model, setupController (starts controller.loadDataTask),
 *              resetController (cancels task, resets step to 0)
 *   uses:      -
 *   siblings:  controllers/form.js, templates/form.hbs
 *   tests:     route-hooks-test.js
 *
 * Thin route wrapper around FormController: starts its loadDataTask on entry
 * and resets the step position on exit.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class FormRoute extends Route {
  model() {}

  setupController(controller /*, model*/) {
    super.setupController(...arguments);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
    set(controller, 'step', 0);
  }
}
